import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts'
import { createProvider } from './vue-apollo'
import i18n from "./i18n";
import Vuelidate from 'vuelidate'
import VueAnalytics from 'vue-analytics';
import draggable from 'vuedraggable';

Vue.config.productionTip = false
Vue.use( VueApexCharts )
Vue.component( 'apexchart', VueApexCharts )
Vue.use( Vuelidate )
Vue.use( VueAnalytics, { id: 'UA-148592499-2', router } )

Vue.use( draggable )
Vue.component( 'draggable', draggable )


new Vue({
    i18n,
    router,
    vuetify,
    store,
    apolloProvider: createProvider(),
    apollo: {
        // Apollo specific options
    },
    render: h => h(App),
}).$mount('#app')
